// Declare all types in here

export const ORDER_TYPE = {
  OCEAN_IMPORT: 'OCEAN_IMPORT',
  OCEAN_EXPORT: 'OCEAN_EXPORT',
  DROP_PICK: 'DROP_PICK',
  RAIL_PICK_UP: 'RAIL_PICK_UP',
  RAIL_DELIVERY: 'RAIL_DELIVERY',
  LAND: 'LAND',
};

// TODO: remove strings once renamed on backend to be the same as here.
// Also remove strings from src/utils/order.ts
export type OrderTypeStrings = keyof typeof ORDER_TYPE | 'Import' | 'Export' | 'Land' | 'RailPickUp' | 'RailDelivery';

export interface Order {
  id: string | number;
  orderType: OrderTypeStrings;

  isExport?: boolean;
  status?: string;
  availability?: string;

  containers?: any[];
  trips?: any[];
  notes?: any[];

  receiver?: any;
  billTo?: any;

  shipLine?: string;
  vesselName?: string;
  vesselEtaString?: string;
  bookingNumber?: string;
  referenceNumber?: string;
  billingReferenceNumber?: string;
  billOfLading?: {
    billOfLadingId: string;
  };
  billingContact?: any;
}


// Object types
export type Address = {
  streetAddress: string;
  suite: string;
  city: string;
  state: string;
  zipCode: string;
};
export interface Invoice {
  id: string | number;
  isInvoiceSent: boolean;
  isInvoicePaid: boolean;
  isArchived?: boolean;
}

export interface Rate {
  id: number;
  amount: number;
  percentage: number;
  rateType: string;
  rateDescription: string;
  quantity: number;
}

export interface Customer {
  id: string | number;
  billingAddress: Address;
  deliveryAddress: Address;
}

export interface Contact {
  id: string | number;
  name: string;
  phoneNumber: string;
  email: string;
}

export type Container = {
  id: string | number;
  internalIndex?: number;
  containerId: string;
  sizeType: string;
  sealNumber: string;
  trips?: any[];
  isActive?: boolean;
  pickupNumber?: string;
  releaseNumber?: string;
  lfd?: string;

  eirIn?: Date;
  eirOut?: Date;
  eirInDate?: any;
  eirOutDate?: any;
  terminalAppointmentDate?: Date;
  terminalAppointmentHasTime?: boolean;
  deliveryAppointmentDate?: Date;
  deliveryAppointmentHasTime?: boolean;
  referenceNumber?: string;
  rates?: any[];
  documents?: any[];
  isHazmat?: boolean;
  freightContents: any;

  // Optional gql types
};

export type Truck = {
  id: string | number;
  vinNumber: string;
  truckNumber: string;
  licensePlate: string;
  isOwnerOperator: boolean;
  isActive: boolean;
};

export type Driver = {
  id: string;
  fullName: string;
};

export type Company = {
  settingsBolTitleStraightBl?: boolean;
  name?: string;
};

export type BaseBusiness = {
  name?: string;
  id: string | number;
};

export type Terminal = {
  id: string;
  shortName: string;
  name: string;
  terminalType: string;
};

// Options enums
// Not a real enum, but used in place
export const TRIP_STATUS = {
  NOT_STARTED: 'Not Started',
  IN_PROGRESS: 'In Progress',
  COMPLETE: 'Complete',
};

export const K_SORT_BY = {
  TERMINAL: 'terminal',
  YARD: 'yard',
  VESSEL: 'vessel',
  CUSTOMER: 'customer',
  TERMINAL_APPT: 'terminalAppt',
  DELIVERY_APPT: 'deliveryAppt',
};

export const DOC_TYPE_TO_NAME = (docType: string) => {
  const knownNames = {
    pod: 'POD',
    eir_in: 'EIR In',
    eir_out: 'EIR Out',
  };
  const name = knownNames[docType];
  if (!name) return docType;
  else return name;
};

export const CONTAINER_TYPES = [
  { name: 'DS (Dry Standard)', value: 'DS' },
  { name: 'DH (Dry High Cube)', value: 'DH' },
  { name: 'FS (Flatbed Standard)', value: 'FS' },
  { name: 'FH (Flatbed High Cube', value: 'FH' },
  { name: 'OS (Open Top Standard)', value: 'OS' },
  { name: 'OH (Open Top High Cube)', value: 'OH' },
  { name: 'RS (Reefer Standard)', value: 'RS' },
  { name: 'RH (Reefer High Cube)', value: 'RH' },
];

export const USER_ROLE = {
  ADMIN: 'Admin',
  USER: 'User',
};
